var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "casino-gambling-slots_svgrepo.com"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x36_35_x2C__Casino_x2C__gambling_x2C__slots_x2C__usa"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.6926 17.3051H3.80199C3.34893 17.3051 2.98167 16.9378 2.98167 16.4847V7.4613C2.98167 7.00825 3.34893 6.64099 3.80199 6.64099H31.6926C32.1456 6.64099 32.5129 7.00825 32.5129 7.4613V16.4847C32.5129 16.9377 32.1456 17.3051 31.6926 17.3051ZM4.62222 15.6644H30.8722V8.28162H4.62222V15.6644Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.6926 32.8909H3.80199C3.34893 32.8909 2.98167 32.5236 2.98167 32.0706V16.4847C2.98167 16.0316 3.34893 15.6644 3.80199 15.6644H31.6926C32.1456 15.6644 32.5129 16.0316 32.5129 16.4847V32.0706C32.5129 32.5237 32.1456 32.8909 31.6926 32.8909ZM4.62222 31.2503H30.8722V17.305H4.62222V31.2503Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.6926 41.0941H3.80199C3.34893 41.0941 2.98167 40.7267 2.98167 40.2737V32.0706C2.98167 31.6176 3.34893 31.2503 3.80199 31.2503H31.6926C32.1456 31.2503 32.5129 31.6176 32.5129 32.0706V40.2737C32.5129 40.7268 32.1456 41.0941 31.6926 41.0941ZM4.62222 39.4534H30.8722V32.8909H4.62222V39.4534Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.4911 8.28162C23.4906 8.28162 23.4901 8.28162 23.4894 8.28162H12.005C11.552 8.28162 11.1847 7.91436 11.1847 7.4613C11.1847 3.84274 14.1287 0.898804 17.7472 0.898804C21.3472 0.898804 24.2795 3.81231 24.3096 7.40536C24.3109 7.42382 24.3114 7.44252 24.3114 7.4613C24.3114 7.91428 23.9442 8.28162 23.4911 8.28162ZM12.8938 6.64099H22.6008C22.2092 4.31614 20.1817 2.53943 17.7473 2.53943C15.3129 2.53943 13.2854 4.31614 12.8938 6.64099Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.0301 8.28162C21.0295 8.28162 21.029 8.28162 21.0285 8.28162H14.466C14.0129 8.28162 13.6457 7.91436 13.6457 7.4613C13.6457 5.1997 15.4856 3.35974 17.7472 3.35974C19.9894 3.35974 21.8171 5.16796 21.8484 7.4029C21.8498 7.42217 21.8504 7.4417 21.8504 7.4613C21.8504 7.91428 21.4832 8.28162 21.0301 8.28162ZM15.4269 6.64099H20.0676C19.7291 5.68607 18.8167 5.00037 17.7472 5.00037C16.6777 5.00037 15.7654 5.68607 15.4269 6.64099Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M27.591 14.8441H7.08324C6.63018 14.8441 6.26292 14.4769 6.26292 14.0238V9.92224C6.26292 9.46918 6.63018 9.10193 7.08324 9.10193H27.591C28.044 9.10193 28.4114 9.46918 28.4114 9.92224V14.0238C28.4114 14.4768 28.044 14.8441 27.591 14.8441ZM7.90347 13.2035H26.7707V10.7426H7.90347V13.2035Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M12.005 30.43H7.08316C6.6301 30.43 6.26285 30.0627 6.26285 29.6097V18.9456C6.26285 18.4926 6.6301 18.1253 7.08316 18.1253H12.005C12.4581 18.1253 12.8253 18.4926 12.8253 18.9456V29.6097C12.8253 30.0627 12.4581 30.43 12.005 30.43ZM7.90347 28.7894H11.1847V19.7659H7.90347V28.7894Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M20.2082 30.43H15.2863C14.8332 30.43 14.466 30.0627 14.466 29.6097V18.9456C14.466 18.4926 14.8332 18.1253 15.2863 18.1253H20.2082C20.6612 18.1253 21.0285 18.4926 21.0285 18.9456V29.6097C21.0285 30.0627 20.6612 30.43 20.2082 30.43ZM16.1066 28.7894H19.3878V19.7659H16.1066V28.7894Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M28.4114 30.43H23.4895C23.0365 30.43 22.6692 30.0627 22.6692 29.6097V18.9456C22.6692 18.4926 23.0365 18.1253 23.4895 18.1253H28.4114C28.8643 18.1253 29.2317 18.4926 29.2317 18.9456V29.6097C29.2317 30.0627 28.8643 30.43 28.4114 30.43ZM24.3098 28.7894H27.591V19.7659H24.3098V28.7894Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M27.591 41.0941H7.08324C6.63018 41.0941 6.26292 40.7267 6.26292 40.2737V35.3519C6.26292 34.8989 6.63018 34.5316 7.08324 34.5316H27.591C28.044 34.5316 28.4114 34.8989 28.4114 35.3519V40.2737C28.4114 40.7268 28.044 41.0941 27.591 41.0941ZM7.90347 39.4534H26.7707V36.1722H7.90347V39.4534Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M25.9504 27.1487C25.4974 27.1487 25.1301 26.7814 25.1301 26.3284V22.2269C25.1301 21.7739 25.4974 21.4066 25.9504 21.4066C26.4034 21.4066 26.7707 21.7739 26.7707 22.2269V26.3284C26.7707 26.7815 26.4034 27.1487 25.9504 27.1487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M17.7472 27.1487C17.2942 27.1487 16.9269 26.7814 16.9269 26.3284V22.2269C16.9269 21.7739 17.2942 21.4066 17.7472 21.4066C18.2003 21.4066 18.5675 21.7739 18.5675 22.2269V26.3284C18.5675 26.7815 18.2003 27.1487 17.7472 27.1487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M9.5441 27.1487C9.09104 27.1487 8.72379 26.7814 8.72379 26.3284V22.2269C8.72379 21.7739 9.09104 21.4066 9.5441 21.4066C9.99716 21.4066 10.3644 21.7739 10.3644 22.2269V26.3284C10.3644 26.7815 9.99716 27.1487 9.5441 27.1487Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlots);
export default __webpack_public_path__ + "static/media/slots.33e925f3d6cfcd7dfc1c3cf257625279.svg";
export { ForwardRef as ReactComponent };